import Player from "@vimeo/player";
import { on } from "delegated-events";
import anime from "animejs";
import { preventScroll, allowScroll } from "../lib/prevent-scroll";

/** @type {HTMLElement} */
const videoOverlay = document.querySelector(
  "[data-project-hero-video-container]"
);

if (videoOverlay) {
  /** @type {HTMLButtonElement} */
  const showButton = document.querySelector("[data-play-cover-video]");
  const iframe = videoOverlay.querySelector("iframe");
  const video = videoOverlay.querySelector("video");
  const player = iframe ? new Player(iframe) : video;

  const showCoverVideo = async () => {
    showButton?.setAttribute("aria-expanded", true);
    videoOverlay.hidden = false;
    videoOverlay.inert = false;
    await Promise.resolve();
    await anime({
      targets: videoOverlay,
      opacity: [0, 1],
      easing: "easeOutQuad",
      duration: 300,
    }).finished;
    player?.play?.();
    preventScroll();
  };

  const hideCoverVideo = async () => {
    allowScroll();
    showButton?.setAttribute("aria-expanded", false);
    /** @type {HTMLElement} */
    const videoOverlay = document.querySelector(
      "[data-project-hero-video-container]"
    );
    player?.pause?.();
    await anime({
      targets: videoOverlay,
      opacity: [1, 0],
      easing: "easeOutQuad",
      duration: 300,
    }).finished;
    videoOverlay.hidden = true;
    videoOverlay.inert = true;
  };

  on("click", "[data-play-cover-video]", showCoverVideo);
  on("click", "[data-close-video-overlay]", hideCoverVideo);
}
